function mhfixedscrool() {
    if($('.type-detail').length){
     var topposition = $('.p-detail-tabs-wrapper').offset().top
     var $checkEl = $("footer#footer");
     var top_of_footer = $checkEl.offset().top;
    }
     var bottom_of_screen = $(window).scrollTop() + $('footer#footer').height();
     //console.log(bottom_of_screen)
     //console.log(top_of_footer)
     if(bottom_of_screen > top_of_footer) {
         $('body').removeClass('sticky-top-bar');
         $("body").addClass('cart-bottom');
         
     }
     else if($(window).scrollTop() < topposition) {
         $('body').removeClass('sticky-top-bar')
         
     } 
     else {
         $("body").removeClass('cart-bottom')
         $('body').addClass('sticky-top-bar');
     }
    
 }

 $(window).scroll(function() {
    mhfixedscrool();
})

$('.scrool .right .buy').attr('data-buy', $('#product-detail-form input[name="priceId"]').attr('value'))
document.addEventListener('ShoptetSimpleVariantChange', function() {
    $('.scrool .right .buy').attr('data-buy', $('#product-detail-form input[name="priceId"]').attr('value'))
});

$('html').on('click', 'body:not(".disabled-add-to-cart") .scrool .buy', function(){
    var product_price_id = $(this).attr('data-buy')
    shoptet.cartShared.addToCart({priceId: product_price_id});
})


